import React, { useEffect, useRef } from "react";
import "../styles/blogSection.css";
import { useNavigate } from "react-router-dom";
import { SlCalender } from "react-icons/sl";
import { useDispatch, useSelector } from "react-redux";
import { getAllBlogs } from "../features/blogs/blogSlice";

const BlogsSection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { blog: blogs = [], isLoading } = useSelector((state) => state.blog);

  useEffect(() => {
    dispatch(getAllBlogs());
  }, [dispatch]);

  const handleReadMore = (slug) => {
    navigate(`/blogs/${slug}`);
  };

  // Reveal animations
  const servicesRef = useRef(null);
  useEffect(() => {
    const revealElements =
      servicesRef.current?.querySelectorAll("[data-reveal]") || [];

    const scrollReveal = () => {
      revealElements.forEach((el) => {
        const inView =
          el.getBoundingClientRect().top < window.innerHeight / 1.15;
        if (inView) el.classList.add("revealed");
        else el.classList.remove("revealed");
      });
    };

    window.addEventListener("scroll", scrollReveal);
    scrollReveal();
    return () => window.removeEventListener("scroll", scrollReveal);
  }, []);

  return (
    <div className="blog-section" ref={servicesRef}>
      <div className="top-header">
        <span data-reveal>Blog & Tips</span>
        <h3 data-reveal>Stories, Trends & Helpful Tips</h3>

        <div className="line-wrapper" data-reveal>
          <div className="short-line"></div>
          <div className="short-line"></div>
        </div>
      </div>

      <div className="blog-card-grid" data-reveal>
        {/* Skeleton loading */}
        {isLoading && (
          <>
            <div className="blog-card skeleton"></div>
            <div className="blog-card skeleton"></div>
            <div className="blog-card skeleton"></div>
          </>
        )}

        {/* Dynamic Blogs */}
        {!isLoading &&
          blogs.slice(0, 3).map((blog, index) => {
            // Extract plain text from HTML
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = blog.description;
            const plainText =
              tempDiv.textContent || tempDiv.innerText || "";
            const snippet = plainText.substring(0, 100) + "...";

            const formattedDate = new Date(blog.createdAt).toLocaleDateString(
              "en-US",
              {
                month: "short",
                day: "numeric",
                year: "numeric",
              }
            );

            return (
              <div className="blog-card" key={index}>
                <img
                  src={blog.images?.[0]?.url}
                  alt={blog.title}
                  title={blog.title}
                />

                <div className="blog-content">
                  <h4 onClick={() => handleReadMore(blog.slug)}>
                    {blog.title}
                  </h4>

                  <p className="blog-date">
                    <SlCalender className="calender-icon" /> {formattedDate}
                  </p>

                  <p className="blog-description">{snippet}</p>

                  <a
                    onClick={() => handleReadMore(blog.slug)}
                    className="read-more"
                  >
                    READ MORE →
                  </a>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default BlogsSection;
